import { useState } from 'react';
import { Translate } from 'react-i18nify';
import { connect } from 'react-redux';
import Modal from '../Modal';
import EditableText from '../EditableText';
import { updateMemberRequest, updateMemberSuccess, updateMemberError } from '../../actions';
import api from '../../api/apiClient';

type Props = {
  isVisible: boolean;
  members: FixMe;
  authToken: string;
  onClose: () => void;
  updateMemberRequest: () => void;
  updateMemberSuccess: (res: any) => void;
  updateMemberError: (err: any) => void;
};

function ShippingAddressEditorModal({
  isVisible,
  onClose,
  members,
  authToken,
  updateMemberError,
  updateMemberRequest,
  updateMemberSuccess
}: Props) {
  const { currentMember, updatingMember } = members;
  const [updates, setUpdates] = useState({});

  const updateProperty = (event, property) => {
    setUpdates({ ...updates, [property]: event.target.value });
  };

  const saveUpdates = () => {
    updateMemberRequest();

    api
      .updateMember(authToken, currentMember.guid, updates)
      .then((response) => {
        updateMemberSuccess(response);
      })
      .catch((error) => {
        updateMemberError(error);
      })
      .finally(onClose);
  };

  if (!currentMember?.personalNumber) {
    return null;
  }

  return (
    <Modal
      headerI18nKey="member_details.shipping_address"
      actionI18nKey="global.buttons.save"
      visible={isVisible}
      onClose={onClose}
      onActionCompleted={saveUpdates}
      actionCompletable
      actionCompleting={updatingMember}
      size="small"
    >
      <div className="columns">
        <div className="column">
          <h4>
            <Translate value="member_details.street_address" />
          </h4>
          <EditableText
            text={currentMember.shippingStreetaddress}
            maxLength="50"
            isEditing={true}
            onChange={(e) => updateProperty(e, 'shippingStreetaddress')}
          />
        </div>
      </div>
      <div className="columns">
        <div className="column">
          <h4>
            <Translate value="member_details.postal_code" />
          </h4>
          <EditableText
            text={currentMember.shippingPostalCode}
            pattern="[0-9\s]+"
            maxLength="6"
            isEditing={true}
            onChange={(e) => updateProperty(e, 'shippingPostalCode')}
          />
        </div>
        <div className="column">
          <h4>
            <Translate value="member_details.city" />
          </h4>
          <EditableText
            text={currentMember.shippingCity}
            maxLength="30"
            isEditing={true}
            onChange={(e) => updateProperty(e, 'shippingCity')}
          />
        </div>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    authToken: state.auth.token.jwt,
    members: state.members
  };
};

const mapActionsToProps = {
  updateMemberRequest,
  updateMemberSuccess,
  updateMemberError
};

export default connect(mapStateToProps, mapActionsToProps)(ShippingAddressEditorModal);
